import * as React from "react";
const SvgFiRrShuttlecock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shuttlecock_svg__a)">
      <path
        fill="#062147"
        d="M23.2 10.073a3.25 3.25 0 0 0-1.354-.81 3.27 3.27 0 0 0-.79-3.334 3.17 3.17 0 0 0-2.106-.878 3.14 3.14 0 0 0-.93-2.117 3.26 3.26 0 0 0-3.285-.74 3.2 3.2 0 0 0-.824-1.407 2.74 2.74 0 0 0-3.128-.512A2.8 2.8 0 0 0 9.89.96a34.2 34.2 0 0 0-6.815 13.6l-1.742 1.74A4.502 4.502 0 0 0 7.7 22.666l1.742-1.742a34.2 34.2 0 0 0 13.6-6.815 2.76 2.76 0 0 0 .158-4.037M19.692 7.4a1.186 1.186 0 0 1-.019 1.656c-.222.221-.956.872-1.046.962l-.007.007c-1.853 1.61-4.553 3.59-5.738 4.446l-.969-.969 6.1-6.1a1.213 1.213 0 0 1 1.68-.002m-5.665-2.12c.027-.03.845-.878.9-.933a1.21 1.21 0 0 1 1.676 0 1.14 1.14 0 0 1 0 1.634l-.019.02-6.084 6.085-.988-.986c.867-1.2 2.894-3.967 4.515-5.82m-2.619-3.017a.757.757 0 0 1 1.105-.045 1.27 1.27 0 0 1 .093 1.65c-.023.026-3.583 4.5-4.527 5.8l-.846-.847a29.6 29.6 0 0 1 4.175-6.558m-5.125 18.99a2.56 2.56 0 0 1-3.536 0 2.5 2.5 0 0 1 0-3.536l1.278-1.278 3.536 3.536zm3.03-2.353L5.1 14.688c.338-1.326.764-2.63 1.273-3.9l6.836 6.836q-1.906.766-3.897 1.276M22 12.043a.76.76 0 0 1-.263.55 29.6 29.6 0 0 1-6.555 4.174l-.865-.865c1.371-.994 4.046-2.975 5.867-4.59a1.294 1.294 0 0 1 1.61.185.73.73 0 0 1 .206.546"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shuttlecock_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShuttlecock;
